import { LitElement, html, css } from "lit";
import "whatwg-fetch";
import dayjs from "dayjs/esm/";
import localeData from "dayjs/esm/plugin/localeData";
import weekday from "dayjs/esm/plugin/weekday";
import updateLocale from "dayjs/esm/plugin/updateLocale";
// Load locale on demand
import "dayjs/esm/locale/es";
import "dayjs/esm/locale/fr";
import "dayjs/esm/locale/it";
import "dayjs/esm/locale/de";

class MatterCalendar extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main-hover: #0b4c1a;
        --main: #087021;
        --main-help: #c4ddca;
        --main-specific-help: #f7fbf8;
        --main-backgroung: #ffffff;

        --grey-main: #333333;
        --grey-help: #bebebe;
        --grey-container: #eeeeee;
        --grey-specific-help: #f5f5f5;

        --status-success: #2abc67;
        --status-info: #5bc0de;
        --status-warning: #f0ad4e;
        --status-error: #d9534f;

        --graph-1: #77b5c3;
        --graph-2: #4863a3;
        --graph-3: #9371ac;
        --graph-4: #d87d7d;
        --graph-5: #d9a46c;
        --graph-6: #e3cd66;
      }
      * {
        font-family: Source Sans Pro;
        box-sizing: border-box;
        text-transform: capitalize;
      }

      :host(:not([showArrows])) .prev,
      :host(:not([showArrows])) .next {
        visibility: hidden;
      }

      :host(:not([showDays])) .calendar_weekdays,
      :host(:not([showYear])) .year {
        display: none;
      }

      :host(:not([showDays])) .calendar_header {
        margin-bottom: 0.6rem;
      }

      .cont-calendar,
      .calendar,
      .calendar_weekdays,
      .calendar_content {
        width: 18.4375rem;
      }

      .calendar {
        /*float: left;*/
        width: 18.4375rem;
        font-weight: 400;
      }

      .calendar_weekdays,
      .calendar_content {
        color: #aaa;
        font-size: 0.875rem;
        font-weight: 600;
        color: #333333;
      }
      .calendar_weekdays div,
      .calendar_content div {
        display: inline-block;
        vertical-align: top;
      }

      .calendar_weekdays {
        border-bottom: 0.0625rem solid #d8d8d8;
        margin-bottom: 0.6rem;
      }
      .calendar_content,
      .calendar_weekdays,
      .calendar_header {
        position: relative;
      }
      .calendar_content:after,
      .calendar_weekdays:after,
      .calendar_header:after {
        content: " ";
        display: table;
        clear: both;
      }
      .calendar_weekdays div,
      .calendar_content div {
        width: 13%;
        height: 13%;
        line-height: 1.875rem;
        overflow: hidden;
        text-align: left;
        background-color: transparent;
        font-size: 0.875rem;
        text-align: center;
      }

      .calendar_weekdays div:last-child,
      .calendar_content div:last-child {
        margin-right: 0px;
      }

      .calendar_content {
        font-weight: normal;
        border-bottom: 0.0625rem solid #d8d8d8;
      }

      .calendar_content .circle {
        overflow: visible;
        position: relative;
      }
      .calendar_content .circle a {
        display: inline-block;
        border: 1px solid #087021;
        background-color: #087021;
        color: #ffffff;
        width: 1.875rem;
        height: 1.875rem;
        border-radius: 50%;
        cursor: pointer;
        text-decoration: none;
        font-weight: bold;
      }

      .calendar_content .varios {
        position: absolute;
        top: -6px;
        left: 13px;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwODcwMjE7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJDYXBhXzIiIGRhdGEtbmFtZT0iQ2FwYSAyIj48ZyBpZD0iQ2FwYV8xLTIiIGRhdGEtbmFtZT0iQ2FwYSAxIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHJlY3QgY2xhc3M9ImNscy0yIiB4PSI4IiB5PSI4IiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiByeD0iMSIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTYsNWg1YTEsMSwwLDAsMSwxLDFWN0g4QTEsMSwwLDAsMCw3LDh2NEg2YTEsMSwwLDAsMS0xLTFWNkExLDEsMCwwLDEsNiw1WiIvPjwvZz48L2c+PC9zdmc+")
          no-repeat;
        width: 2rem;
        height: 1rem;
        margin: 0;
        float: right;
        z-index: 1;
      }

      .calendar_content .circle a:visited {
        border: 1px solid #d5e0da;
        background-color: #d5e0da;
        color: #087021;
      }

      .calendar_content .circle a:hover {
        background-color: #0b4c1a;
        color: #ffffff;
        text-decoration: underline;
      }

      .calendar_content .circle matter-icon {
        float: right;
        font-size: 8px;
        position: relative;
        top: -4px;
        right: 3px;
      }

      .calendar_content .circle matter-icon:hover {
        color: #ffffff;
      }

      .calendar_content div {
        margin-bottom: 0.6rem;
      }
      .calendar_content div.today {
        font-weight: bold;
        font-size: 18px;
        color: #409edd;
      }

      .calendar_header {
        width: 100%;
        text-align: center;
        background: #e5e4e4;
        padding: 0 10px;
        height: 2.5rem;
        padding-top: 10px;
        padding-bottom: 10px;

        position: relative;
      }

      .calendar_header .monthName {
        font-size: 0.875rem;
        font-weight: bold;
      }

      button.switch-month {
        background-color: transparent;
        padding: 0;
        outline: none;
        border: none;
        -webkit-transition: color 0.2s;
        transition: color 0.2s;
        cursor: pointer;
        font-size: 13px;

        position: absolute;
      }
      button.prev {
        left: 15px;
      }
      button.next {
        right: 15px;
      }

      button.switch-month:hover {
        color: #5eade2;
      }
      button.switch-month:active {
        background-color: rgba(113, 113, 125, 0.4);
      }
      .calendar_header span {
        color: #333333;
        line-height: 1.7;
      }

      .cont-more {
        margin-top: 1rem;
        text-align: right;
      }

      .icono-more {
        display: inline-block;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABJklEQVQ4T6VTy0rDQBQ9Z0Qa/YqO7gSpUDfu6q8o+FroVD9A3PsIgk/wW8zOjQWL0J2kXyERca7MNIlp2hSCsxi4c++55z7OEKWzeLjctkpaQlmhoC1Ej8KBsux/Xn/0iuEsGoHRDwB2ygkL9mMSxruZnYMDo2UGaMyVhLHH+avRbe5ReDcOljMAEYAOwNOiTyj7X1fDe84f69acxdskq2wm4TAKTNOBn8v+H4U1Tmd1obPBjp0LR/pGiINR5rxUb/0x57x5CxTcMjDaldRJwb7UqsGVWojY6OpzCk7qMgtxwcAsbQHyVHdgALc5UpR9rQtWVq37PU9XVvWeAXil/V9hWcnVO0/HmSprQtvZg1OcEtlQlqtCuJ81sEreLfnyfRn3i7P5BZbKjUw2Ufr3AAAAAElFTkSuQmCC")
          no-repeat;
        background-size: cover;
        width: 14px;
        height: 14px;
        margin: 0;
        position: relative;
        top: 2px;
        left: 2px;
      }

      .enlace-more {
        font-size: 14px;
        color: #087021;
        text-decoration: none;
        text-transform: none;
      }
      .enlace-more:hover {
        color: #0b4c1a;
        text-decoration: underline;
      }
    `;
  }

  static get properties() {
    return {
      date: { type: String },
      endpointUrl: { type: String },
      inputDate: { type: String },
      inputUrl: { type: String },
      inputNodeRoot: { type: String },
      inputMoreUrl: { type: String },
      inputMoreTitle: { type: String },
      inputEventsByDay: { type: String },
      showYear: { type: Boolean, reflect: true },
      showArrows: { type: Boolean, reflect: true },
      showDays: { type: Boolean, reflect: true },
      lang: { type: String },
      response: { type: Array },

      _error: { type: String },
      _currentDate: { type: Object },
    };
  }

  constructor() {
    super();
    this.date = "";
    this.inputDate = "";
    this.inputUrl = "";
    this.inputNodeRoot = "";
    this.inputMoreUrl = "";
    this.inputMoreUrl = "";
    this.inputEventsByDay = "";
    this.showYear = false;
    this.showArrows = false;
    this.showDays = false;
    this.lang = "es";
    this.endpointUrl = "";

    this.response = [];
    dayjs.extend(localeData); // use plugin
    dayjs.extend(weekday); // use plugin
    dayjs.extend(updateLocale); // use plugin
    dayjs.updateLocale("es", {
      weekdaysMin: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
    });

    dayjs.locale(this.lang);
    this._currentDate = dayjs(this.getDateByString(this.date));
  }

  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  render() {
    const weekdays = this.getWeekDays();
    const month = dayjs(this._currentDate).locale(this.lang).format("MMMM");
    return html`
      <div class="cont-calendar">
        <div class="calendar">
          <div class="calendar_header">
            <button
              class="prev switch-month"
              data-attribute="prev"
              @click=${this.buttonHandler}
            >
              &#10094;
            </button>
            <span class="monthName">
              ${month}
              <span class="year"> ${this._currentDate.format("YYYY")} </span>
            </span>
            <button
              class="next switch-month"
              data-attribute="next"
              @click=${this.buttonHandler}
            >
              &#10095;
            </button>
          </div>

          <div class="calendar_weekdays">
            ${weekdays.map((day) => html` <div>${day}</div> `)}
          </div>

          <div class="calendar_content">
            ${this._error
              ? html` <div class="error">${this._error}</div> `
              : this.populateCells().map(
                  (date) =>
                    html`
                      ${this.findEventDay(date)
                        ? html`
                            <div class="circle">
                              ${this.isMultiple(date)
                                ? html` <div class="varios"></div> `
                                : html``}
                              <a
                                class="enlace ${this.isMultiple(date)
                                  ? "multiple"
                                  : ""}"
                                href="${this.findEventDay(date)}"
                              >
                                ${date}
                              </a>
                            </div>
                          `
                        : html` <div>${date}</div> `}
                    `
                )}
          </div>
        </div>
        ${this.inputMoreUrl != "" ? html`
          <div class="cont-more">
            <a class="enlace-more" href="${this.inputMoreUrl}" title="${this.inputMoreTitle}">
              <div class="icono-more"></div> ${this.inputMoreTitle}
            </a>
          </div>
        `: html``}
      </div>
    `;}

  updated(changedProperties) {
    changedProperties.forEach((_, propName) => {
      if (["endpointUrl"].includes(propName)) {
        this.updatedResponse();
      }
      if (["date"].includes(propName)) {
        this._currentDate = dayjs(this.getDateByString(this.date));
      }
    });
    this.addFont();
  }

  updatedResponse() {
    /* Reestablecemos la variable de error para evitar que salga mensaje anterior */
    this._error = "";

    let urlAux = this.endpointUrl;
    urlAux = urlAux.replace(/&amp;/g, "&");
    urlAux = urlAux.replace(/&gt;/g, ">");

    if (urlAux !== undefined && urlAux !== null && urlAux !== "") {
      urlAux = urlAux.replace("&amp;", "&");

      window
        .fetch(urlAux, {
          mode: "cors",
        })
        .then((response) => {
          if (response.ok) {
            response
              .json()
              .then((responseJSON) => {
                const elements = [];

                // Obtenemos la raiz del array
                let _res = responseJSON;
                if (this.inputNodeRoot) {
                  const str = this.inputNodeRoot.split(".");
                  _res = this.lookupPosition(str, _res);
                }

                _res.forEach((item) => {
                  const objAux = this.findElementIntoJSON(item);

                  /* INPUT URL */
                  const url = objAux[this.inputUrl]
                    ? objAux[this.inputUrl]
                    : "";

                  /* INPUT DATE */
                  const date = objAux[this.inputDate]
                    ? objAux[this.inputDate]
                    : "";

                  // Variable para calcular si hay mas de un evento por dia
                  const multiple = objAux[this.inputEventsByDay]
                    ? objAux[this.inputEventsByDay]
                    : "";
                  let isMultiple = false;

                  if (Array.isArray(multiple) && multiple.length > 1) {
                    isMultiple = true;
                  }

                  elements.push({
                    date,
                    url,
                    isMultiple,
                  });
                });

                /* AÑADIR ELEMENTOS */
                this.response = elements;
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {});
    }
  }

  // Función que devuelve una fecha dado un String
  getDateByString() {
    let dateResult = null;
    const parts = this.date.split("/");
    if (parts.length === 3) {
      dateResult = new Date(+parts[2], parts[1] - 1, +parts[0]);
    } else {
      dateResult = new Date();
    }
    return dateResult;
  }

  // Dias de la semana
  getWeekDays() {
    dayjs.locale(this.lang);
    return dayjs.weekdaysMin();
  }

  // Encuentra el evento
  findEventDay(day) {
    let url = "";
    if (day !== "") {
      const aux = this._currentDate;
      const eventDay = aux.date(day).format("DD/MM/YYYY").toString();
      const eventFound = this.response.filter(
        (event) => event.date === eventDay
      );
      if (eventFound.length > 0 && eventFound[0].url) {
        const eventURL = eventFound[0].url;
        url = eventURL;
      }
    }

    return url;
  }

  isMultiple(day) {
    let isMultiple = false;

    if (day !== "") {
      const aux = this._currentDate;
      const eventDay = aux.date(day).format("DD/MM/YYYY").toString();
      const eventFound = this.response.filter(
        (event) => event.date === eventDay
      );

      if (eventFound.length > 0 && eventFound[0].isMultiple) {
        isMultiple = eventFound[0].isMultiple;
      }
    }

    return isMultiple;
  }

  // Avance y retroceso
  buttonHandler(e) {
    const move = e.currentTarget.getAttribute("data-attribute");
    const oldDate = this._currentDate;
    this._currentDate = this._currentDate.add(
      move === "next" ? 1 : -1,
      "month"
    );
    this.requestUpdate(this._currentDate, oldDate);
  }

  // Calcula el número de días que debe de mostrar por mes y el día de la semana de comienzo
  populateCells() {
    const cells = [];
    const firstDay = this._currentDate
      .locale(this.lang)
      .startOf("month")
      .weekday();
    const lastDate = this._currentDate.daysInMonth();
    for (let i = 1; i <= lastDate + firstDay; i += 1) {
      cells.push(i <= firstDay ? "" : i - firstDay);
    }
    return cells;
  }

  /* eslint-disable */
  findElementIntoJSON(element) {
    const root = {};
    (function levels(data, index) {
      const suffix =
        Object.prototype.toString.call(data) === "[object Array]" ? "]" : "";

      for (const key in data) {
        if (!data.hasOwnProperty(key)) {
          continue;
        }

        root[index + key + suffix] = data[key];

        if (Object.prototype.toString.call(data[key]) === "[object Array]") {
          levels(data[key], `${index + key + suffix}[`);
        }

        if (
          Object.prototype.toString.call(data[key]) === "[object Object]"
        ) {
          levels(data[key], `${index + key + suffix}.`);
        }
      }
    })(element, "");
    return root;
  }
  /* eslint-enable */

  // Metodo que recorre el JSON hasta llegar al atributo seleccionado
  // eslint-disable-next-line class-methods-use-this
  lookupPosition(str, _res) {
    str.forEach((i) => {
      _res = _res[i];
    });

    return _res;
  }

  formatDate(date) {
    const year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : `0${month}`;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : `0${day}`;

    return `${day}/${month}/${year}`;
  }
}

if (!window.customElements.get("matter-calendar")) {
  window.customElements.define("matter-calendar", MatterCalendar);
}
